import Employe from "./Employe/Employe";
import RWDLockPage from "./RWDLockPage";

import ModalSuccess from "./ModalSuccess/ModalSuccess";

import StageValidationHOC from "../../../../../../hocs/StageValidation.HOC";
import { mode } from "../../../../../../app/mode";
import { isTerminal } from "../../../../../../constants";
import { $api } from "../../../../../../redux/services/request.config";

import RequestInput from "../../../../../common/Inputs/RequestInput/RequestInput";

import {
    getSubordinatesThunkAction,
} from "../../../../../../redux/actions/Requests/RequestsFromLeader/RecruitmentToWork/thunk/getSubordinates.thunk.action";
import { Modal } from "../../../../../common/Modal/Modal";
import BackHandlerModal from "../../../../../common/Modal/ModalConditions/Requests/BackHandlerModal/BackHandlerModal";
import SaveSuccessModal from "../../../../../common/Modal/ModalConditions/Requests/SaveSuccessModal/SaveSuccessModal";
import ModalBanOverlay from "../../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";
import Error500Modal from "../../../../../common/Modal/ModalConditions/Requests/Error500Modal/Error500Modal";

import DropdownMenuTest from "../../../../../common/Menu/DropdownMenuTest/DropdownMenuTest";
import UButton from "../../../../../common/Button/UButton/UButton";

import {
    emptyCurrentRequest,
} from "../../../../../../redux/actions/Requests/currentRequestControls/emptyCurrentRequest";


import RecruitmentToWorkOnHolidaysApplication
    from "../../../../../../frontend.classes/Requests/nonBasic/RecruitmentToWorkOnHolidays.application";
import RequestConfirmation
    from "../../../../../common/Modal/ModalConditions/Requests/RequestConfirmation/RequestConfirmation";

import {
    getCompensationTypesThunkAction,
} from "../../../../../../redux/actions/Requests/RequestsFromLeader/RecruitmentToWork/thunk/getCompensationTypes.thunk.action";
import {
    getJobHoursThunkAction,
} from "../../../../../../redux/actions/Requests/RequestsFromLeader/RecruitmentToWork/thunk/getJobHours.thunk.action";
import {
    addBasicInputHandlerCurrentRequest,
} from "../../../../../../redux/actions/Requests/currentRequestControls/addBasicInputHandler.currentRequest";

import {
    getAviableRequestTypesThunkAction,
} from "../../../../../../redux/actions/Requests/RequestsFromLeader/thunk/getAviableRequestTypes.thunk.action";
import {
    validationControlCurrentRequest,
} from "../../../../../../redux/actions/Requests/currentRequestControls/validationControl.currentRequest";

import RecruitmentToWorkOnHolidaysService
    from "../../../../../../frontend.services/LeaderRequests/RecruitmentToWorkOnHolidays.service";
import NotificationWindowRequests from "../../../../../common/NotificationWindowRequests/NotificationWindowRequests";
import {
    setValidatedApplicationAction,
} from "../../../../../../redux/actions/Requests/CurrentRequest/setValidatedApplication.action";
import {
    setCurrentDetailsAction,
} from "../../../../../../redux/actions/Documents/Leader/testDetails/setCurrentDetails.action";
import {
    dropdownSelectionCurrentRequest,
} from "../../../../../../redux/actions/Requests/currentRequestControls/dropdownSelection.currentRequest";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";


import { useNavigate, useSearchParams } from "react-router-dom";

import "./RecruitmentToWorkOnHolidays.scss";


const TestHOCComponent = ({ props, back, next, newTuple }) => {
    return (
        <ModalBanOverlay shown={true}>
            <div style={{
                top: "calc(100dvh - 80%)",
                left: "calc(100dvw - 80%)",
                position: "fixed",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                height: "30vh",
                background: "lavender",
            }}>
                <h1 onClick={() => {
                    console.log("NEW TUPLE: ", newTuple);
                }}>
                    testHOCComponent {props.name}
                </h1>
                <button onClick={() => next(newTuple)}>next</button>
                <button onClick={back}>back</button>
            </div>

        </ModalBanOverlay>
    );
};


const RecruitmentToWorkOnHolidays = () => {
    let notificationWindowKP;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const subordinates = useSelector(state => state.requests.subordinates);
    const currentRequest = useSelector(state => state.requests.currentRequest);

    const [notificationWindow, setNotificationWindow] = useState(false);
    const [modalWindowKP, setModalWindowKP] = useState(null);
    const [sendButtonLoading, setSendButtonLoading] = useState(false);
    const [onValidation, setOnValidation] = useState(false);

    // NOTIFICATION IN CONTROL PROCEDURES CONTENT
    const [requestStatus, setRequestStatus] = useState(false);
    const [modalStatus, setModalStatus] = useState(false);
    const [modalSuccessStatus, setModalSuccessStatus] = useState(false);
    const [modalSentStatus, setModalSentStatus] = useState(false);
    const [modalError, setModalError] = useState({
        sign: false,
        validation: false,
        status: false,
        saving: false,
    });
    console.log("modalWindowKP: ", modalWindowKP);
    console.log("notificationWindow: ", notificationWindow);

    const [isRunningSaveHandler, setIsRunningSaveHandler] = useState(false);
    const [isRunningSendHandler, setIsRunningSendHandler] = useState(false);

    const [stageModalWindow, setStageModalWindow] = useState(false);

    function inputHandler(e, field) {
        const value = e.target.value;
        dispatch(addBasicInputHandlerCurrentRequest({ field, value }));
        dispatch(validationControlCurrentRequest(field, true));
    }


    function backHandler(e) {
        navigate("/main/hr-services/requests/leader");
    }

    function selectHandler(event, element, stateProperty) {
        if (stateProperty === "initiatorPid") {
            console.log(element);
            dispatch(getSubordinatesThunkAction({pid: element.pid}));

        }
        dispatch(dropdownSelectionCurrentRequest({ event, element, stateProperty }));

    }
    const confirmAction = {
        back: () => {
            setStageModalWindow(null);
            closeErrorModal();
        },
        next: async (newTuple, props) => {
            try {
                const response = await $api.post(`/v1/managers/requests/rvd/applications/${currentRequest?.initiatorPid}`, currentRequest);
                if (response.data) {
                    props.setOnValidation(false);
                    newTuple[0][0].props.responseData = response.data;
                    setStageModalWindow(StageValidationHOC(newTuple));

                    dispatch(setCurrentDetailsAction(response.data));
                }
                // setStageModalWindow(StageValidationHOC(newTuple));

            } catch (e) {
                setStageModalWindow(null);

                setModalError(prev => {
                    return {
                        ...prev, status: true, validation: true,
                    };
                });

            }
        },
        props: {
            setRequestStatus: setRequestStatus,
            stateLoader: setSendButtonLoading,
            onValidation: onValidation,
            setOnValidation: setOnValidation,
            setModalError: setModalError,
            sendButtonLoading: sendButtonLoading,
            setModalSentStatus: setModalSentStatus,
            requestStatus: notificationWindowKP,
        },
    };
    const actionsOK = {
        back: () => {
            // navigate("/documents?tab=4")
            console.log("BACK");
        },
        next: (newTuple) => {
            console.log("NEXT", newTuple);

            // newTuple[1][0].props.name = "NEW HOC";
            // setStageModalWindow(StageValidationHOC(newTuple));
        },
        props: {
            name: "testHOC",
            currentRequest: currentRequest,
        },
        // newTuple: null,
    };

    const testHOC = StageValidationHOC([
        [confirmAction, RequestConfirmation],
        [actionsOK, ModalSuccess],

    ]);


    async function requestStageValidationHandler() {
        if (RecruitmentToWorkOnHolidaysService.validation(currentRequest, dispatch)) {
            // setOnValidation(true);
            setIsRunningSendHandler(true);
            // console.log(currentRequest);
            try {
                const response = await $api.post(`/v1/managers/requests/rvd/validations/${currentRequest?.initiatorPid}`, currentRequest);
                if (response.status === 200) {
                    // console.log(response);
                    if (response.data.length > 0) {
                        let blockingArray = response.data.map((element, index) => {
                            let temp;
                            if (element.details && element.details.length) {
                                temp = element.details.filter((worker, indexWorker) => (
                                    worker.isBlocking === true
                                ));
                                temp = temp.map((el, index) => {
                                    return { ...el, code: el.jobDate, block: 1, message: el.reason };
                                });
                                // console.log(temp);

                            }
                            // element.details && element.details.length && element.details.filter((worker, indexWorker) => (
                            //     worker.isBlocking === true
                            // ));
                            return { ...element, isSuccess: false, details: temp };
                        });
                        blockingArray = blockingArray.filter(worker => worker.details.length > 0);
                        const controlArray = response.data.map((element, index) => {
                            element.details && element.details.length && element.details.filter((worker, indexWorker) => (
                                !worker.isBlocking === true
                            ));
                            return element;
                        });
                        setRequestStatus({
                            block: blockingArray,
                            validControl: controlArray,
                        });
                        notificationWindowKP = {
                            block: blockingArray,
                            validControl: controlArray,
                        };
                        dispatch(setValidatedApplicationAction({
                            block: blockingArray,
                            validControl: controlArray,
                        }));

                        if (blockingArray.length) {//requestStatus && requestStatus.block && requestStatus.block.
                            setIsRunningSendHandler(false);

                        } else {


                            // const { data } = await $api.post("/v1/managers/requests/rvd/validations", requestData);
                            //
                            // setOnValidation(false);
                            setIsRunningSendHandler(false);

                            setStageModalWindow(testHOC);

                            // const component = RequestValidationService.stageValidation(data);
                            // setModalWindowKP(component);
                        }
                    } else {
                        console.log(response);
                        // setOnValidation(false);
                        // setModalSentStatus(true);
                        setIsRunningSendHandler(false);

                        setStageModalWindow(testHOC);
                        // console.log("--!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!--");

                    }
                }

            } catch (error) {
                setIsRunningSendHandler(false);
                setModalError(prev => {
                    return {
                        ...prev, status: true, validation: true,
                    };
                });
                console.log(error?.response);
            }

        } else {
            console.log("VALIDATION WORK");
        }

    }

    useEffect(() => {
        dispatch(getAviableRequestTypesThunkAction({id:21, navigate:navigate }));
        dispatch(getCompensationTypesThunkAction());
        dispatch(getJobHoursThunkAction());
        setRequestStatus(false);
        dispatch(
            emptyCurrentRequest(
                new RecruitmentToWorkOnHolidaysApplication({
                    leaveTypeId: 21,
                    reason: "",

                    employees: [
                        {
                            pid: null,
                            days: [
                                // {
                                //     jobDate: null, // "2024-05-01",
                                //     jobHours: null, // 8.5,
                                //     compensationType: null, // 2,
                                //     restDate: null, // "2024-05-04"
                                // },
                            ],
                        },
                    ],

                }),
            ),
        );
    }, []);

    useEffect(() => {
        if (requestStatus) { //&& !requestStatus.isSuccess
            // console.log("useeffect -------->>>>>>>", requestStatus);
            setNotificationWindow(true);

        }
    }, [requestStatus]);

    function closeErrorModal(e ) {
        document.body.style.overflow = "scroll";
        e &&  e.stopPropagation();
        setModalError({
            sign: false,
            validation: false,
            status: false,
            saving: false,
        });
        document.body.focus();
    }
    return (
        <>
            {/*{*/}
            {/*    mode === "PROD"*/}
            {/*        ? <RWDLockPage />*/}
            {/*        : (*/}
            <div className={"recruitment-to-work"}>
                <div className="sub-header" style={{ width: "767px", margin: "0" }}>
                                Привлечение к работе в выходные и праздничные дни
                </div>
                <div style={{marginBottom: "40px"}} >
                <DropdownMenuTest
                    // optionsLoader={typesListLoader}
                    styleName={  "types"}
                    // label={"заявки по рабочему времени"}
                    initialMenuMessage={"От имени кого оформляется заявка *"}
                    listOfOptions={currentRequest && currentRequest.delegators}
                    stateProperty={"initiatorPid"}
                    currentRequest={currentRequest}
                    visibleIndex={"100"}
                    selectOptionClick={selectHandler}
                    // isValidKey={
                    //     currentRequest
                    //     && currentRequest
                    //     && currentRequest.initiatorPid
                    //         ? currentRequest.initiatorPid
                    //         : false
                    // }
                    // showBackButton={isTerminal}
                />
                </div>
                {
                    currentRequest && currentRequest.initiatorPid ?
                        <>
                            <RequestInput
                                errorMessage={currentRequest &&
                                currentRequest.isValid &&
                                currentRequest.isValid.reason ?
                                    "" : "Обязательное поле"}
                                value={currentRequest && currentRequest.reason}
                                basicInput={true}
                                maxLength={400}
                                stateProperty={"reason"}
                                changeHandler={(e) => inputHandler(e, "reason")}
                                label={"Расшифровка причины привлечения к работе в выходные, праздничные дни *"}
                                letter={400}
                                parentStyle={"unpaid-practice"}
                                placeholder={"В связи с [         ] прошу привлечь" +
                                    " к работе в выходной, праздничный день следующих работников:"}

                            />

                            {
                                currentRequest &&
                                currentRequest.employees &&
                                currentRequest.employees.map((employee, index) => {
                                    return (
                                        <div
                                            key={uuid()}
                                            style={{ marginBottom: "65px" }}>
                                            <Employe
                                                parentStyle={"recruitment-to-work"}
                                                employee={employee}
                                                index={index}
                                                key={index}
                                                employeesLength={currentRequest.employees.length}
                                            />
                                        </div>

                                    );
                                })
                            }
                            <div style={{ display: "flex", flexDirection: "column", gap: "30px", position: "absolute" }}>
                                {requestStatus &&
                                    requestStatus.block &&
                                    requestStatus.block.map((worker, index) => {
                                        return (
                                            <>
                                                <NotificationWindowRequests
                                                    pixels={(index) * 450}
                                                    notificationWindowStatus={worker}
                                                    setNotificationWindowStatus={setRequestStatus}
                                                    notificationWindowStyle={notificationWindow}
                                                    blockingMessages={true}
                                                />
                                            </>
                                        );


                                    })
                                }
                            </div>
                        </>
                        : null
                }



                {/* MOCK MODAL START */}
                {/*<button onClick={requestStageValidationHandler}>*/}
                {/*    validate*/}
                {/*</button>*/}
                <p className={"postpone-vacation-comment__underline"}>
                    <span className="required_text">* </span>
                                Поля обязательные для заполнения
                </p>
                {
                    modalWindowKP
                }
                {stageModalWindow}
                {/* MOCK MODAL END */}
                <div className="wt-request-buttons">
                    <UButton
                        onClick={backHandler}
                        className="wt-request-buttons__default">
                        {!isTerminal && "назад"}
                        {isTerminal && "Назад"}
                    </UButton>
                    <div className="wt-request-buttons__two-buttons">
                        {/*{*/}
                        {/*    // !props.references &&*/}
                        {/*    <UButton*/}
                        {/*        disabled={true}*/}
                        {/*        // onClick={props.saveHandler}*/}
                        {/*        className="wt-request-buttons__default"*/}
                        {/*        loading={isRunningSaveHandler}*/}
                        {/*    >*/}
                        {/*        {!isTerminal && "cохранить"}*/}
                        {/*        {isTerminal && "Cохранить"}*/}
                        {/*    </UButton>*/}
                        {/*}*/}

                        <UButton
                            disabled={ !currentRequest?.initiatorPid}
                            onClick={requestStageValidationHandler}
                            className="wt-request-buttons__default"
                            loading={isRunningSendHandler}
                        >
                            {!isTerminal && "направить заявку"}
                            {isTerminal && "Направить заявку"}
                        </UButton>
                    </div>
                </div>
                <Modal shown={modalStatus} close={setModalStatus}>
                    <BackHandlerModal
                        // handler={saveHandler}
                        close={setModalStatus}
                    />
                </Modal>
                {/*SAVE SUCCESS*/}
                <Modal shown={modalSuccessStatus} close={setModalSuccessStatus}>
                    <SaveSuccessModal
                        route={"/main/hr-services"}
                        close={setModalSuccessStatus}
                    />
                </Modal>
                {/*REQUEST SEND*/}
                <ModalBanOverlay shown={modalSentStatus} close={setModalSentStatus}>
                    <RequestConfirmation

                        setRequestStatus={setRequestStatus}
                        stateLoader={setSendButtonLoading}
                        onValidation={onValidation}
                        setOnValidation={setOnValidation}
                        setModalError={setModalError}
                        sendButtonLoading={sendButtonLoading}
                        route={"/main/hr-services/"}
                        back={setModalSentStatus}
                        requestStatus={requestStatus}


                    />
                </ModalBanOverlay>
                {modalError.status && (
                    <ModalBanOverlay shown={modalError} close={setModalError}>
                        <Error500Modal
                            modalError={modalError}
                            setModalError={setModalError}
                            function={closeErrorModal}

                        />
                    </ModalBanOverlay>
                )}
            </div>
            {/*)*/}
            {/*}*/}
        </>
    );
};

export default RecruitmentToWorkOnHolidays;
